/**
 * Regroupe les rafraîchissements rapprochés (debounce + dernière intention gagne).
 * Évite les reload storms quand plusieurs sous-systèmes réagissent au même événement.
 */
export type RefreshScheduler = {
  schedule: (key: string, fn: () => void) => void;
  cancel: (key: string) => void;
  cancelAll: () => void;
};

export function createRefreshScheduler(delayMs = 280): RefreshScheduler {
  const timers = new Map<string, ReturnType<typeof setTimeout>>();
  const pending = new Map<string, () => void>();

  return {
    schedule(key: string, fn: () => void) {
      pending.set(key, fn);
      const existing = timers.get(key);
      if (existing != null) {
        clearTimeout(existing);
      }
      timers.set(
        key,
        setTimeout(() => {
          timers.delete(key);
          const run = pending.get(key);
          pending.delete(key);
          run?.();
        }, delayMs)
      );
    },
    cancel(key: string) {
      const timer = timers.get(key);
      if (timer != null) {
        clearTimeout(timer);
        timers.delete(key);
      }
      pending.delete(key);
    },
    cancelAll() {
      for (const timer of timers.values()) {
        clearTimeout(timer);
      }
      timers.clear();
      pending.clear();
    },
  };
}
